export var StoreModeEnum;
(function (StoreModeEnum) {
    StoreModeEnum["REAL"] = "REAL";
    StoreModeEnum["TEST"] = "TEST";
    StoreModeEnum["DEMO"] = "DEMO";
})(StoreModeEnum || (StoreModeEnum = {}));
//# sourceMappingURL=store-mode.enum.js.map